<template>
    <div class="addr-list">
        <label class="profile-radio" @click="checkRadio">
            <span class="pro-radio" v-bind:class="{'pro-radio-checked':this.addr.is_default == 1}">
                <span class="pro-radio-inner"></span>
                <input type="radio" class="pro-radio-input">
            </span>
            <div class="address_item">
                <p class="address-content">{{addr.name}}</p>
                <p class="address-content">{{addr.mobile}}</p>
                <p class="address-content">{{addr.all_address}}</p>
            </div>
        </label>
        <div class="address-edit">
            <button class="btn-modify btn-big btn-text" @click="modAddr = true">{{$t('user_center_btn_modify')}}</button>
            <button class="btn-modify btn-big btn-text" @click="deleteAddress">{{$t('user_center_btn_delete')}}</button>
        </div>

        <modal v-model="modAddr" title="修改地址">
            <input type="hidden" v-model="addAddressGroup.address_id">
            <div class="addr_modal">
                <p class="addr_modal_tips">{{$t('user_center_Coupons_Use_tips')}}: <span>*</span>{{$t('add_address_must_item')}}</p>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_area')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select name="addAddressGroup_country" v-model="addAddressGroup.country">
                            <option :value="item.id" v-for="(item,index) in countrys"
                                    :key="index">   {{item.country_name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_address')}}<span>*</span>
                    </div>
                    <div class="addr_item2">
                        <textarea cols="30" rows="6" :placeholder="$t('add_address_address_full')" v-validate="'required'" name="addAddressGroup_address"
                                  :class="{'is-error': errors.has('addAddressGroup_address')}"
                                  v-model="addAddressGroup.address"></textarea>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('add_address_zip_code')}}
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|numeric'" name="addAddressGroup_zipcode" :placeholder="$t('add_address_zip_code_full')"
                               :class="{'is-error': errors.has('addAddressGroup_zipcode')}"
                               v-model="addAddressGroup.zipcode">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_name')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <input type="text" v-validate="'required|min:1'" :placeholder="$t('add_address_first_name_full')" name="addAddressGroup_last_name"
                               :class="{'is-error': errors.has('addAddressGroup_last_name')}"
                               v-model="addAddressGroup.name"
                        >
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber">
                        {{$t('about_ifree_join_sub_number')}}<span>*</span>
                    </div>
                    <div class="addr_item1">
                        <select v-model="addAddressGroup.area_code" style="margin-bottom: 10px;">
                            <option v-for="(item,index) in cityiso" :value="item.area_code" :key="index">
                                {{item.area_code}} {{item.name}}
                            </option>
                        </select>
                        <input v-validate="'required|min:11'" name="bind_phone" v-model="addAddressGroup.mobile"
                               :class="{'is-error': errors.has('bind_phone')}" type="text" class="form-input"
                               :placeholder="this.$t('add_number_number')">
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <Checkbox style="font-size: 14px;color: #5E6D82;" @on-change="check_default" class="checkALL" v-model="default_single">
                            {{$t('add_address_defult_address')}}
                        </Checkbox>
                    </div>
                </div>
                <div class="addr_group">
                    <div class="addr_laber"></div>
                    <div class="addr_item1">
                        <button class="btn-pt btn-blue" @click="saveAddress">
                            {{$t('determine_btn')}}
                        </button>
                    </div>
                </div>
            </div>

            <div slot="footer"></div>
        </modal>
    </div>

</template>

<script>
    import modal from '../Common/Modal.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                modAddr: false,
                addAddressGroup: this.addr,
                default_single:false,
                countrys:'',
                bind_iso:'86',
                cityiso:[]

            }
        },
        props: {
            addr: Object,
            id: Number

        },
        mounted () {
            let module = 'index.php/index/user/getcountry'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.lang = this.$i18n.locale
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        console.log(response.data)
                        this.countrys =response.data.data.country_list
                    }
                }.bind(this))

            // 获取国家iso
            this.iso()
        },
        components: {
            modal
        },
        methods: {
            check_default(){
                if(this.default_single == true){
                    this.default = 1
                }
            },
            saveAddress () {
                let module = 'index.php/index/user/editaddress'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.get('users')['user_id']
                data.lang = this.$i18n.locale
                for (let item in this.addAddressGroup) {
                    data[item] = this.addAddressGroup[item]
                }
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.$emit('modifyaddr', resp.data.data)
                        this.modAddr = false
                        this.$Message.success(this.$t('modify_suceess'))
                        // 页面刷新
                        location.reload()
                    }
                }.bind(this))
            },
            cencelAddress () {
                this.modAddr =false
            },
            deleteAddress () {
//        在这里删除数据要
                this.$emit('deladdr', this.checkedNum)
            },
            checkRadio (e) {
                if (e.target.nodeName === 'INPUT') {
                    this.$emit('checked')
                }
            },
            iso () {
                let data = {}
                let module = 'index.php/index/other/isocountry'
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            this.cityiso = resp.data.data.country_list
                        }
                    }.bind(this))
            }
        }
    }
</script>

<style lang="scss" >

    .addr-list {
        display: flex;
        border-bottom: 1px solid #E5E9F2;
        padding: 15px 0;
        .addr_modal{
            .addr_modal_tips{
                font-size: 14px;
                color: #5E6D82;
                padding: 15px 0;
            }
            span{
                color: #0084ff;
            }
            .addr_group{
                padding: 5px 0;
                display: flex;
                button{
                    color: white;
                    background: #0084FF;
                    border: none;
                    padding: 5px 0;
                    width: 100px;
                    border-radius: 5px;
                }
                .addr_laber{
                    width: 15%;
                    line-height: 32px;
                    text-align: right;
                    padding-right: 10px;
                    min-width: 90px;
                }
                .addr_item1{
                    width: 85%;
                    select,input{
                        background: #FFFFFF;
                        border: 1px solid #C0CCDA;
                        border-radius: 4px;
                        width: 40%;
                        padding:5px 0 5px 3px;
                        min-width: 170px;
                    }
                }
                .addr_item2{
                    width: 85%;
                    textarea{
                        padding-left: 3px;
                        background: #FFFFFF;
                        border: 1px solid #C0CCDA;
                        border-radius: 4px;
                        width: 100%;
                        margin:5px 0;
                    }
                }
            }
        }
    }


    .profile-radio {
        flex: 1;
        display: flex;
        position: relative;
        .pro-radio {
            margin-right: 5px;
        }
        .address_item{
            width:100%;
            max-width:300px;
            min-width:200px;
            padding-left:10px;
            .address-content {
                font-size: 16px;
                margin-right: 20px;
            }
        }

        .pro-radio-inner {
            display: inline-block;
            width: 14px;
            height: 14px;
            position: relative;
            top: 0;
            left: 0;
            background-color: #fff;
            border: 1px solid #dddee1;
            border-radius: 50%;
            transition: all .2s ease-in-out;
            &:after {
                position: absolute;
                width: 8px;
                height: 8px;
                left: 2px;
                top: 2px;
                border-radius: 6px;
                display: table;
                border-top: 0;
                border-left: 0;
                content: " ";
                background-color: #2d8cf0;
                opacity: 0;
                transition: all .2s ease-in-out;
                transform: scale(0);
            }
        }

        .pro-radio-input {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
            opacity: 0;
            cursor: pointer;
        }

        .pro-radio {
            &.pro-radio-checked .pro-radio-inner:after {
                opacity: 1;
                transform: scale(1);
                transition: all .2s ease-in-out;
            }
        }
    .btn-modify{
        line-height: 18px;
    }


    }
    @media (max-width:414px) {
        .addr_modal{
            max-height: 400px;
            overflow-y: scroll;
        }
    }

    @media screen and (max-width:320px) {
        .modal .modal-wrap.modal-middle{
            top: 15%;
        }
        .addr_modal{
            max-height: 350px;
            overflow-y: scroll;
        }
    }
</style>



// WEBPACK FOOTER //
// Address.vue?c2865eac